export default __webpack_public_path__ + "choose_banner.97110a.svg";